import React, { Component } from 'react';
import { Container, Card } from 'semantic-ui-react';

import EducationList from './EducationList';
import SkillsAndLanguages from './SkillsAndLanguages';

export default class Education extends Component {
    render () {
        return (
            <Container id="education" fluid>
                <Card fluid>
                    <Card.Content header="Education & Skills" />
                    <Card.Content description={<EducationList />} />
                    <Card.Content header={"Skills & Languages"} />
                    <Card.Content description={<SkillsAndLanguages />} />
                </Card>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Education.js